module.exports = __webpack_public_path__ + "img/chest-yellow-3x.03ed01b1.png";